






















import {Component, Prop, Vue} from 'vue-property-decorator';
import NavDropdown from '@/components/Views/UI/NavDropdown.vue';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {Sync} from 'vuex-pathify';
import ToolbarMixin from '@/mixins/ToolbarMixin.vue';
import {drawerNavigation, nil} from '@/common';
import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';

@Component({
    components: {NavDropdown},
})
export default class SiteNavbar extends Mixins(UserRoleMixin, ToolbarMixin, ScreenSizeMixin) {
    @Prop({default: []})
    public navigation!: any[];
    @Sync('booking/step') public bookingStep!: number;

    public showLogo = true;
    get bookCTA() {
        return this.bookingStep === 1 ? 'Book Now' : 'Finish Booking';
    }
    public created() {
        this.onResize(() => {
            this.calculateShowLogo();
        });
        this.calculateShowLogo();
    }
    public mounted() {
        this.calculateShowLogo();
    }
    public calculateShowLogo() {
        this.showLogo = this.windowWidth() > 340;
    }
    public get dashboardNavigation() {
        return drawerNavigation.filter((x) => !nil(x.path));
    }
    public logout() {
        this.$store.dispatch('auth/logout');
        this.$router.replace('/');
    }
    public get minimalToolbar() {
        return this.userIsAdmin && this.isXS(null);
    }
}
